import { useState } from 'react';

const faqs = [
  {
    question: 'Who provides home inspections near me?',
    answer:
      'Inspectors.com serves Baytown, East Harris County, Liberty County, and Chambers County in Texas. We match you with a licensed local inspector for fast scheduling and reliable service in your area.',
  },
  {
    question: 'How much does a home inspection cost?',
    answer:
      'Costs vary based on property size, type, and location. Pricing reflects the scope of inspection needed. The most accurate way to determine cost is to request a quote specific to your property.',
  },
  {
    question: 'How long does a home inspection take?',
    answer:
      'Most inspections take 2–4 hours depending on the property. After completion, a detailed report is typically delivered quickly so you can review findings and move forward.',
  },
];

export default function FAQ() {
  const [open, setOpen] = useState<number | null>(null);

  const scrollToContact = () => {
    const el = document.querySelector('#contact');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="faq" className="py-24 md:py-32 bg-[#F5F4F1]">
      <div className="max-w-3xl mx-auto px-6 md:px-14">

        {/* Header */}
        <div className="mb-12">
          <div className="flex items-center gap-3 mb-4">
            <div className="w-8 h-px bg-[#C9A961]"></div>
            <span className="text-[#C9A961] text-xs font-semibold uppercase tracking-[0.2em]">FAQs</span>
          </div>
          <h2
            className="text-4xl md:text-5xl font-bold text-[#1A1A1A]"
            style={{ fontFamily: "'Playfair Display', serif" }}
          >
            Frequently Asked
            <br />
            Questions
          </h2>
        </div>

        {/* Accordion */}
        <div className="flex flex-col gap-3 mb-12">
          {faqs.map((faq, i) => (
            <div
              key={i}
              className={`rounded-xl border transition-all duration-200 ${
                open === i
                  ? 'border-[#C9A961]/35 bg-white'
                  : 'border-[#1A1A1A]/8 bg-white hover:border-[#C9A961]/20'
              }`}
            >
              <button
                onClick={() => setOpen(open === i ? null : i)}
                className="w-full flex items-center justify-between px-7 py-5 text-left cursor-pointer"
              >
                <span
                  className={`text-base font-semibold pr-4 transition-colors duration-200 ${
                    open === i ? 'text-[#C9A961]' : 'text-[#1A1A1A]'
                  }`}
                >
                  {faq.question}
                </span>
                <div
                  className={`flex-shrink-0 w-7 h-7 flex items-center justify-center rounded-full transition-colors duration-200 ${
                    open === i ? 'bg-[#C9A961] text-white' : 'bg-[#1A1A1A]/6 text-[#1A1A1A]'
                  }`}
                >
                  <i className={`text-sm ${open === i ? 'ri-subtract-line' : 'ri-add-line'}`}></i>
                </div>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  open === i ? 'max-h-60 pb-6' : 'max-h-0'
                }`}
              >
                <p className="text-[#1A1A1A]/62 text-base leading-relaxed px-7">{faq.answer}</p>
              </div>
            </div>
          ))}
        </div>

        {/* CTA below FAQ */}
        <div className="flex flex-col sm:flex-row items-center gap-4">
          <button
            onClick={scrollToContact}
            className="bg-[#C9A961] text-white font-semibold text-sm px-8 py-3.5 rounded-md hover:bg-[#b8944f] transition-colors duration-200 cursor-pointer whitespace-nowrap"
          >
            Schedule Inspection
          </button>
          <a
            href="tel:+12814217355"
            className="flex items-center gap-2 text-sm font-semibold text-[#1A1A1A]/65 hover:text-[#C9A961] transition-colors whitespace-nowrap"
          >
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-phone-line text-[#C9A961] text-xs"></i>
            </div>
            Or call (281) 421-7355
          </a>
        </div>
      </div>
    </section>
  );
}
